"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPromoIdentifierText = exports.StyledPromoIdentifier = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _typography = require("../../fuse-typography-element/src/typography");
var _config = require("./config");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
var backgroundColorConfig = _config.style.backgroundColor,
  textColorConfig = _config.style.textColor;
var StyledPromoIdentifier = exports.StyledPromoIdentifier = _styledComponents["default"].div.attrs({
  className: 'fuse-promo-identifier'
}).withConfig({
  displayName: "styled-promo-identifier__StyledPromoIdentifier",
  componentId: "sc-g7eqys-0"
})(["background-color:", ";padding-bottom:var(--spacing-global-space1);padding-top:var(--spacing-global-space1);text-align:center;width:100%;"], function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return backgroundColorConfig[backgroundColor];
});
var StyledPromoIdentifierText = exports.StyledPromoIdentifierText = (0, _styledComponents["default"])(_typography.TypographyComponent).attrs({
  className: 'fuse-promo-identifier__text',
  'data-testid': 'fuse-promo-identifier__text'
}).withConfig({
  displayName: "styled-promo-identifier__StyledPromoIdentifierText",
  componentId: "sc-g7eqys-1"
})(["margin:0;color:", ";"], function (_ref2) {
  var textColor = _ref2.textColor;
  return textColorConfig[textColor];
});